import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailCampaignsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager />
    </PageContainer>
  );
}

interface AdminEmailCampaignsSearch {
  dialog?: "new";
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (raw: Record<string, unknown>): AdminEmailCampaignsSearch => ({
    dialog: raw.dialog === "new" ? "new" : undefined,
  }),
  component: AdminEmailCampaignsPage,
});
